
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#422680] via-[#341671] to-[#280659] text-white overflow-hidden w-full">
      <div className="max-w-5xl mx-auto text-center relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-white to-[#F54952] bg-clip-text text-transparent">
              Ready to Strengthen Your Security?
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
            {/* Was "Join thousands of organisations and professionals who trust
                Educ4te" — an unsubstantiated volume claim. Replaced with what the
                offering actually is, which is also more useful to the reader. */}
            Australian-delivered cybersecurity and AI training, plus fixed-price security assessments for Microsoft environments.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/assessments" className="w-full sm:w-auto">
              <Button 
                size="lg"
                className="w-full sm:w-auto bg-[#F54952] hover:bg-[#AE2D68] text-white text-lg px-8 py-6 transition-all transform hover:scale-105"
              >
                Schedule Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Link to="/training" className="w-full sm:w-auto">
              <Button 
                size="lg"
                variant="outline"
                className="w-full sm:w-auto border-2 border-white bg-transparent text-white hover:bg-white hover:text-[#422680] text-lg px-8 py-6 transition-all"
              >
                Explore Courses
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
